import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models/index';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './installation-inspection-info.component.html',
    standalone: false
})
export class InstallationInspectionInfoPluginComponent {
  public inspection: Inspection;
  public config: any;
  public editRoute = ['installation', 'inspectioninfo', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.inspection = inspection;
    this.cdRef.detectChanges();
  }
}
PluginComponent.plugins['installationinspectioninfo'] = InstallationInspectionInfoPluginComponent;
